import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui';
import { MessageSquare, AlertCircle } from 'lucide-react';
import { useDashboardMetrics } from '@/hooks/queries/useDashboard';
import { WidgetSkeleton, WidgetError } from './WidgetSkeleton';
import { cn } from '@/lib/utils';

export function ConversacionesWidget() {
  const { data, isLoading, isError } = useDashboardMetrics();

  if (isLoading) return <WidgetSkeleton />;
  if (isError || !data) return <WidgetError message="Error al cargar conversaciones" />;

  const esperando = data.conversaciones.esperando_respuesta;
  const hasUrgent = esperando > 5;

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-gray-600">
          Conversaciones Activas
        </CardTitle>
        <div className="p-2 bg-green-50 rounded-lg">
          <MessageSquare className="h-4 w-4 text-green-600" />
        </div>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{data.conversaciones.activas}</div>
        <div className="flex items-center gap-1 mt-1">
          {hasUrgent && <AlertCircle className="h-3 w-3 text-orange-500" />}
          <p className={cn(
            'text-xs',
            hasUrgent ? 'text-orange-600' : 'text-gray-500'
          )}>
            {esperando} esperando respuesta
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
